<template>
  <v-card
    class="elevation-10 radius-10 fill-height"
    :style="'border-top: 5px solid ' + color"
  >
    <v-card-text class="pa-6 grey--text text--darken-2">
      <slot />
    </v-card-text>
  </v-card>
</template>

<script>
    export default {
        name: 'StatCard',
        props: {
            color: {
                type: String,
                default: '#ffffff'
            }
        }
    }
</script>

<style scoped>

</style>
